export function cleanVatIdentifier(vat?: string | null): string {
  return vat?.replace(/\s/g, '').replace(/\./g, '').toUpperCase() ?? ''
}

export function canProceedWithMandateSetup(params: {
  hasSiret: boolean
  cleanedCountryCompanyIdentifier?: string
  cleanedVatIdentifier?: string
  companyName?: string
  optin: boolean
  isValidEmail: boolean
}): boolean {
  if (!params.optin || !params.isValidEmail) {
    return false
  }

  if (params.hasSiret) {
    const length = params.cleanedCountryCompanyIdentifier?.length ?? 0

    return length === 11 || length === 14
  }

  const length = params.cleanedVatIdentifier?.length ?? 0

  return (length === 12 || length === 13) && (params.companyName ?? '') !== ''
}
